import React from 'react'
import { FaUser, FaUserTie } from 'react-icons/fa'
import { BsPersonLinesFill, BsCheck2Circle } from 'react-icons/bs'
import { RiMapPinUserFill } from 'react-icons/ri'
import { GiCancel } from 'react-icons/gi'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useRef } from 'react'

export const SingleRequest = () => {
  toast.configure()
  const inputRef = useRef(null)
  const email = localStorage.getItem('email')
  const firstName = localStorage.getItem('firstName')
  const lastName = localStorage.getItem('lastName')
  const [file, setFile] = useState(null)
  const [mode, setMode] = useState([])
  const [values, setValues] = useState({
    id: '',
    department: '',
    RAFname: '',
    RALname: '',
    from: '',
    amount: '',
    method: '',
    description: '',
    category: '',
  })
  const [errMsg, setErrMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const [whitespace, setWhiteSpace] = useState(false)

  // name validation
  const validate = (values) => {
    if (values.trim().length === 0) {
      toast.error('White or empty space is not allowed.', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'success1',
        autoClose: 5000,
      })
      setWhiteSpace(true)
    } else {
      setWhiteSpace(false)
    }
  }

  // const [tempValue, setTempValue] = useState([{ temp: '' }])

  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  const resetFileInput = () => {
    inputRef.current.value = null
    setErrMsg('')
    setSuccessMsg('')
  }

  // const handleTemp = (e, index) => {
  //   let data = [...tempValue]
  //   data[index][e.target.name] = e.target.value
  //   setTempValue(data)
  // }

  const handleFile = (file) => {
    setErrMsg('')
    setSuccessMsg('')
    setFile(file)

    if (
      file.type === 'image/png' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/jpg' ||
      file.type === 'application/pdf'
    ) {
      setSuccessMsg('File uploded Successfully!')
    } else {
      setErrMsg('Failed to upload file; the format is not supported!')
    }
    if (file.size > 5000000) {
      setErrMsg('File is too large ! Maximum file size is 5 MB.')
    }
  }

  const getMode = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/getAllPaymentMode')
      .then((res) => {
        setMode(res.data.data)
      })
      .catch((err) => {})
  }

  const submitRequest = async (e) => {
    e.preventDefault()
    const formData = new FormData()

    const data = {
      resubmit: false,
      email: email,
      payee_name: firstName + ' ' + lastName,
      dept_name: values.department,
      desig_id: values.id,
      manager_name: values.RAFname + ' ' + values.RALname,
      paid_amount: parseFloat(values.amount),
      mode_id: values.method,
      purpose_of_expenditure: values.description,
      date_of_expense: values.from,
      expenditure_category: values.category,
    }

    formData.append('data', JSON.stringify(data))
    formData.append('invoice', file)
    await axios
      .post(Baseurl.nodeLocal + 'request/initiateNewRequest', formData)
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setValues({
          id: '',
          department: '',
          RAFname: '',
          RALname: '',
          from: '',
          amount: '',
          method: '',
          description: '',
          category: '',
        })
        resetFileInput()
      })
      .catch((err) => {})
  }
  useEffect(() => {
    getMode()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const onclick = () => {
  //   let newfield = { temp: '' }

  //   setTempValue([...tempValue, newfield])
  // }
  // console.log(tempValue)
  return (
    <div>
      <div className="row">
        <h6 className="text-muted col-md-5 mb-4">
          * &nbsp;Make sure to provide accurate details. <br /> &nbsp;
          &nbsp;Otherwise your reimbursement request could be affected.
        </h6>

        <h5 className="text-primary col-md">Expense Details</h5>
      </div>
      <form onSubmit={submitRequest}>
        <div className="row">
          <div className="col-md-4">
            <div className="row">
              <div className="col-12">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Employee Name"
                    aria-label="Employee Name"
                    aria-describedby="basic-addon1"
                    value={firstName + ' ' + lastName}
                    readOnly
                  />
                  <span className="input-group-text" id="basic-addon1">
                    <FaUser />
                  </span>
                </div>
              </div>
              <div className="col-12">
                {' '}
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Employee ID"
                    aria-label="Employee ID"
                    aria-describedby="basic-addon1"
                    name="id"
                    value={values.id}
                    onChange={handleChange}
                    onBlur={() => {
                      validate(values.id)
                    }}
                    required
                  />
                  <span className="input-group-text" id="basic-addon1">
                    <BsPersonLinesFill />
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Department"
                    aria-label="Department"
                    aria-describedby="basic-addon1"
                    name="department"
                    value={values.department}
                    onChange={handleChange}
                    onBlur={() => {
                      validate(values.department)
                    }}
                    required
                  />
                  <span className="input-group-text" id="basic-addon1">
                    <RiMapPinUserFill />
                  </span>
                </div>
              </div>
              <div className="col-12">
                {' '}
                <div class="input-group">
                  <input
                    type="text"
                    aria-label="First name"
                    class="form-control"
                    placeholder="RA First Name"
                    name="RAFname"
                    value={values.RAFname}
                    onChange={handleChange}
                    onBlur={() => {
                      validate(values.RAFname)
                    }}
                    required
                  />
                  <input
                    type="text"
                    aria-label="Last name"
                    class="form-control"
                    placeholder="RA Last Name"
                    name="RALname"
                    value={values.RALname}
                    onBlur={() => {
                      validate(values.RALname)
                    }}
                    onChange={handleChange}
                    required
                  />
                  <span class="input-group-text">
                    {' '}
                    <FaUserTie />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-1 d-flex justify-content-center">
            <div className="vr" style={{ height: '400px' }}></div>
          </div>
          <div className="col-md-7">
            {/* <h5 className="mb-4 text-muted">Expense Details</h5> */}
            <div className="row">
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">
                    <h6>Expense Date</h6>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="from"
                    value={values.from}
                    onChange={handleChange}
                    required
                    max={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">
                    <h6>Amount</h6>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={values.amount}
                    onChange={handleChange}
                    required
                    step="0.01"
                    min="0"
                    max="100000"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">
                    <h6>Payment Method</h6>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="method"
                    value={values.method}
                    onChange={handleChange}
                    required
                  >
                    <option selected disabled value="">
                      Select
                    </option>
                    {mode?.map((i, index) => {
                      return (
                        <option value={i.mode_id} key={index}>
                          {i.mode_name}
                        </option>
                      )
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md">
                {' '}
                <div className="mb-3">
                  <label className="form-label">
                    <h6>Category</h6>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="category"
                    value={values.category}
                    onChange={handleChange}
                    required
                  >
                    <option selected disabled value="">
                      Select
                    </option>
                    <option value="Business Cards">Business Cards</option>
                    <option value="Business Meals">Business Meals</option>
                    <option value="Dues">Dues</option>
                    <option value="Legal Fees">Legal Fees</option>
                    <option value="License Fees">License Fees</option>
                    <option value="Mileage">Mileage</option>
                    <option value="Office Supplies">Office Supplies</option>
                    <option value="Passport fee">Passport fee</option>
                    <option value="Postage">Postage</option>
                    <option value="Printer Cartridges">
                      Printer Cartridges
                    </option>
                    <option value="Printer Paper">Printer Paper</option>
                    <option value="Software">Software</option>
                    <option value="Stationery">Stationery</option>
                    <option value="Subscriptions">Subscriptions</option>
                    <option value="Telephones">Telephones</option>
                    <option value="Tools">Tools</option>
                    <option value="Training Fees">Training Fees</option>
                    <option value="Travel">Travel</option>
                    <option value="Work Clothing">Work Clothing</option>
                    <option value="Gift">Gift</option>
                    <option value="Miscellaneous office expense">
                      Miscellaneous office expense
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {' '}
                <div className="mb-3">
                  <label className="form-label">
                    <h6>Purpose of Expenditure(s) / Description</h6>
                    <h6 className="text-muted">
                      Please give detailed reasons for all expenditures. Maximum
                      400 characters.
                    </h6>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    maxLength={400}
                  />
                </div>
              </div>
              <div className="col-md-12">
                {' '}
                <div className="mb-2">
                  <label className="form-label">
                    <h6>Invoice</h6>
                    <h6 className="text-muted">
                      .png, .jpg, .pdf file only. Maximum file size is 5 MB.
                    </h6>
                  </label>
                  <input
                    type="file"
                    // accept="image/png, image/jpg,.pdf"
                    className="form-control"
                    name="invoice"
                    onChange={(e) => {
                      handleFile(e.target.files[0])
                    }}
                    required
                    ref={inputRef}
                  />
                </div>
                {errMsg ? (
                  <div className="d-flex">
                    <h6 className="text-danger mx-1">{errMsg}</h6>
                    <GiCancel style={{ color: '#dc3545' }} />
                  </div>
                ) : successMsg ? (
                  <div className="d-flex">
                    <h6 className="text-success mx-1">{successMsg}</h6>
                    <BsCheck2Circle style={{ color: '#198754' }} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              {/* {tempValue.map((item, index) => {
                return (
                  <div key={index}>
                    <input
                      name="temp"
                      value={item.temp}
                      onChange={(e) => handleTemp(e, index)}
                    />
                    <button
                      onClick={() => {
                        setI(i - 1)
                      }}
                    >
                      X
                    </button>
                  </div>
                )
              })} */}
              {/* <button
                className="btn btn-outline-primary me-md-2"
                type="button"
                onClick={() => {
                  // onclick()
                }}
              >
                Add Another
              </button> */}

              <button
                className={
                  errMsg ||
                  whitespace ||
                  file === null ||
                  values.RAFname === '' ||
                  values.RALname === '' ||
                  values.amount === '' ||
                  values.category === '' ||
                  values.department === '' ||
                  values.from === '' ||
                  values.id === '' ||
                  values.method === ''
                    ? 'btn btn-primary disabled me-md-2'
                    : 'btn btn-primary me-md-2'
                }
                type={
                  errMsg ||
                  whitespace ||
                  file === null ||
                  values.RAFname === '' ||
                  values.RALname === '' ||
                  values.amount === '' ||
                  values.category === '' ||
                  values.department === '' ||
                  values.from === '' ||
                  values.id === '' ||
                  values.method === ''
                    ? 'button'
                    : 'submit'
                }
              >
                Submit Request
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
